module.exports = __webpack_public_path__ + "static/media/ic-notif-periodic-obligation.ddc3623f.svg";